import ClassSvc from '@/common/service/modules/ClassSvc';

export default {
  async fetchClassDetail({ commit }, params) {
    const { data } = await ClassSvc.getStudentOrderList(params);
    await commit('setClassInfo', data.entity);
  },

  async fetchOrderDetail({ commit }, params) {
    const { entity } = await ClassSvc.getOrderDetail(params);
    await commit('setOrderInfo', entity);
  }
};
